import Consultations from '@services/Consultations'
import history from '@services/History'
import moment from 'moment'

import { getDate, getNumDay } from '@utilities/date'
import { NUM_DAYS_WEEK } from '@modules/admin/schedules/constants'
import { getSchedules } from './action-ts'

let eventGuid = 0

export const handleCheckbox = ({ activeDays, setActiveDays, selected }) => {
  const result = activeDays.map((item) => {
    if (item.day === selected.day) return { ...selected, active: !selected.active }
    return item
  })
  setActiveDays(result)
}

export const handleEvents = ({ events, setActiveButton, setCurrentEvents }) => {
  setActiveButton(hasSlotEachDay(events))
  setCurrentEvents(events)
}

const hasSlotEachDay = (schedules) => {
  let days = {}
  schedules.forEach((event) => {
    let day = moment(event.start).format('dddd')
    if (!days[day]) days[day] = true
  })
  return Object.keys(days).length === NUM_DAYS_WEEK
}

const formatSchedules = (schedules) => {
  return schedules.map((item) => {
    let end
    if (isMidnight(item.end)) {
      end = new Date(item.end.setHours(23, 59, 59))
    } else {
      end = new Date(item.end.setSeconds(0))
    }
    return { ...item, end }
  })
}

export const fetchSchedules = async ({
  setCurrentEvents,
  setActiveDays,
  setProfessionalName,
  setOnHolidays,
  setTimeZone,
  setActiveButton,
  params,
}) => {
  try {
    const { data } = await Consultations.professional.show(params.id)
    const activeResult = getActiveResult(data)
    const schedules = getSchedules(data)

    const formattedSchedules = formatSchedules(schedules)

    setActiveButton(!!schedules.length)
    setCurrentEvents(formattedSchedules)
    setActiveDays(activeResult)
    setProfessionalName(data.name)
    setOnHolidays(!!data.on_holidays)
    setTimeZone(data.timezone)
  } catch (e) {
    console.log(e)
  }
}

export const submit = async ({ currentEvents, activeDays, onHolidays, timeZone, params, t }) => {
  const correctDay = currentEvents.some((item) => isSameDay(item.start, item.end))
  if (!correctDay) {
    alert(t('CalendarDragNotAllowed'))
    return
  }
  const result = getBackendFormat({ currentEvents, activeDays })
  const requestBody = {
    day_schedules: result,
    on_holidays: +onHolidays,
    timezone: timeZone,
  }
  try {
    await Consultations.schedules.update(params.id, requestBody)
    history.push('/professional/' + params.id)
  } catch (e) {
    console.log(e)
  }
  console.log('result', requestBody)
}

export const removeRange = (clickInfo) => {
  clickInfo.event.remove()
}

export const isSameDay = (start, end) => getNumDay(start) === getNumDay(end)
export const isNextDay = (start, end) => moment(getDate(end)).diff(getDate(start), 'days') === 1
export const isNight = (date) => moment(date).hours() === 0 && moment(date).minutes() === 0

export const handleDateSelect = (selectedInfo, currentEvents, t) => {
  const { start, end, startStr, endStr, allDay, view } = selectedInfo
  let calendarApi = view.calendar
  //solo deja setear horarios si es el mismo dia o el día siguiente a las 00:00
  if (isSameDay(start, end) || (isNight(end) && isNextDay(start, end))) {
    // ej. [30, 30, 1, 2, 2, 3]
    const dayList = currentEvents.map((event) => {
      return moment(event.start).format('D')
    })
    const selectedDay = moment(start).format('D')
    //only two times available per day
    const availableToSet = repeatedTimesDay(dayList, selectedDay) < 2
    // clear date selection
    calendarApi.unselect()
    // set the event/shift into the calendar

    const newEnd = end.toISOString() === '2025-03-30T01:00:00.000Z' ? new Date('2025-03-30T00:59:59.999Z') : endStr
    if (availableToSet && !includeNextDay(selectedInfo)) {
      calendarApi.addEvent({
        id: createEventId(),
        start: startStr,
        end: newEnd,
        allDay: allDay,
        className: 'custom-slot',
      })
    }
  } else {
    // clear date selection
    calendarApi.unselect()
    alert(t('CalendarDragNotAllowed'))
    return
  }
}

export const repeatedTimesDay = (list, selectedDay) => {
  // get how many appearance of events per day
  return list.reduce((acc, day) => (selectedDay === day ? ++acc : acc), 0)
}

export const includeNextDay = ({ start, end }) => {
  return moment(start).day() !== moment(end).day() && moment(end).minutes() !== 0
}

export const handleEnd = (end) => {
  //if (isMidnight(end)) return 1439 //1440
  if (isMidnight(end)) return 1440
  return getParsedTime(end)
}

export const isMidnight = (end) => {
  // le pasamos la fecha end porque podría empezar a las 00:00 y eso no sería midnight
  return end.toString().match('00:00:') || end.toString().match('23:59:')
}

export const getBackendFormat = ({ currentEvents, activeDays }) => {
  let day_schedules = {}
  const orderedEvents = currentEvents.sort((a, b) => moment(a.start).unix() - moment(b.start).unix())
  orderedEvents.forEach((item) => {
    // console.log(moment(item.start).day(), moment(item.end).day())

    let weekendDay = moment(item.end).locale('en').format('dddd').toLowerCase()
    if (isMidnight(item.end)) {
      weekendDay = moment(new Date(item.end - 60))
        .locale('en')
        .format('dddd')
        .toLowerCase()
    }

    const secondRange = !!day_schedules[weekendDay]
    if (secondRange) {
      day_schedules[weekendDay] = {
        ...day_schedules[weekendDay],
        range_2_1: getParsedTime(item.start),
        range_2_2: handleEnd(item.end),
        start_second_period: getParsedTime(item.start),
        end_second_period: handleEnd(item.end),
        active: +activeDays.find((item) => item.day === weekendDay).active,
      }
    } else {
      //first range
      day_schedules[weekendDay] = {
        range_1_1: getParsedTime(item.start),
        range_1_2: handleEnd(item.end),
        start_first_period: getParsedTime(item.start),
        end_first_period: handleEnd(item.end),
        range_2_1: getParsedTime(item.start),
        range_2_2: handleEnd(item.end),
        start_second_period: getParsedTime(item.start),
        end_second_period: handleEnd(item.end),
        active: +activeDays.find((item) => item.day === weekendDay).active,
      }
    }
  })
  //Borrar porque no se necesita un array sino un objeto
  // let result = [];
  //for (let key in day_schedules) {
  //result.push({[key]: {...day_schedules[key], active: +activeDays.find(item => item.day === key).active}})
  //}
  return day_schedules
}

export const getActiveResult = (data) => {
  return data.schedules.map((item) => {
    return {
      day: item.day,
      active: !!item.active,
    }
  })
}

export const INITIAL_EVENTS = [
  {
    id: createEventId(),
    title: 'Timed event',
    start: `2021-09-01T08:00:00`,
    end: `2021-09-01T10:00:00`,
  },
]

export function createEventId() {
  return String(eventGuid++)
}

export const getParsedTime = (date) => {
  const time = moment(date).format('HH:mm')
  const splitTime = time.split(':')
  let hours = parseInt(splitTime[0])
  let minutes = parseInt(splitTime[1])

  if ('2025-03-30T00:59:59.000Z' === new Date(date).toISOString()) {
    hours = 2
    minutes = 0
  }

  return moment
    .duration({
      hours,
      minutes,
    })
    .asMinutes()
}
